<img
  src={'/marketing/icons/location.svg'}
  class="h-[13px] md:ml-1 mr-3 lg:mr-4"
  width={13}
  height={13}
  loading="lazy"
  alt="location icon"
/>
